import React from 'react'

const LogoutPopup = () => {
    return (
        <div className="modal fade" id="logoutModal" tabIndex={-1} aria-labelledby="logoutModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="suspendModalLabel">Confirmation alert!</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                    </div>
                    <div className="modal-body">
                        <h5>Are you sure you want to logout?</h5>
                    </div>
                    <div className="modal-footer modal-center justify-content-center">
                        <button type="button" className="btn btn-decline" data-bs-dismiss="modal">No</button>
                        <a href="auth-cover-signin" className="btn btn-approve">Yes</a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LogoutPopup